import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAdditionalDataFormRequest } from "../../../../http/requests/applications/additionalData.http";

export const fetchGetAdditionalData = createAsyncThunk("additionalData/get", async () => {
  const response = await getAdditionalDataFormRequest();
  return response.data;
});
